import { render, staticRenderFns } from "./RepairScreen.vue?vue&type=template&id=28a15902"
import script from "./RepairScreen.vue?vue&type=script&lang=js"
export * from "./RepairScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports